import React from 'react';

import {
  SortieVehiculeRequestDto,
  SortieVehiculeViolationDtoFormFieldEnum,
} from 'lib_api/lib/api/gen';

import WrappedCheckbox from 'components/WrappedComponents/Form/FormFields/Checkbox/Checkbox';
import { useApi } from 'hooks/ApiStoreContext';
import { SortieVehicule } from 'types/SortieVehicule';
import { CSSUtils } from 'utils/CSSUtils';

import {
  generateSortieVehiculeRequestDtoFromSortieVehicule,
  validateSortieVehiculeRule,
} from '../../../utils';

interface VerificationPreSortieCheckboxProps {
  dossierId: string;
  values: SortieVehicule;
}

export const VerificationPreSortieInfoProprietaireCheckbox: React.FC<
  VerificationPreSortieCheckboxProps
> = ({
  dossierId,
  values,
}: VerificationPreSortieCheckboxProps): React.ReactElement => {
  const { GardienFourriereControllerApi: gfController } = useApi();
  const key: keyof SortieVehicule = 'isConfirmedInfosProprietaire';

  async function validator(value: string | undefined): Promise<void> {
    const sortieVehiculeRequestDto: SortieVehiculeRequestDto =
      generateSortieVehiculeRequestDtoFromSortieVehicule({
        ...values,
        [key]: value,
      });
    return await validateSortieVehiculeRule(
      dossierId,
      gfController,
      sortieVehiculeRequestDto,
      SortieVehiculeViolationDtoFormFieldEnum.NOM_PROPRIETAIRE_COHERENT,
    );
  }

  return (
    <WrappedCheckbox
      wrapperProps={{
        values,
        fieldKey: 'isConfirmedInfosProprietaire',
        itemProps: {
          label: 'Les champs du propriétaire sont identiques',
          hasFeedback: true,
          labelCol: { span: CSSUtils.defaultLabelCol },
          rules: [
            {
              validator: async (
                _rule,
                value: string | undefined,
              ): Promise<void> => {
                return await validator(value);
              },
            },
          ],
        },
      }}
      checkboxProps={{
        name: 'isConfirmedInfosProprietaire',
      }}
    />
  );
};
